// extracted by mini-css-extract-plugin
export default {"logoContainer":"AppLinking_logoContainer__l5Nov","logo":"AppLinking_logo__maC7O","description":"AppLinking_description__bQnzO"};